import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadLockPeriods = createAction('[StaticData] Load LockPeriods');

export const loadLockPeriodsSuccess = createAction(
  '[StaticData] Load LockPeriods Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadLockPeriodsFailure = createAction('[StaticData] Load LockPeriods Failure', props<{ error: any }>());
